<template>
    <el-dialog title="试卷作答信息"
               width="70%"
               top="10vh"
               custom-class="exam-similar-detail"
               :visible="value"
               :close-on-click-modal="true"
               :append-to-body="false"
               :modal-append-to-body="false"
               @close="$emit('input', false)"
    >
        <el-table class="similar-detail-table sc-table"
                  ref="similarTable"
                  :data="filterData"
                  :border="true"
                  :stripe="false"
                  height="65vh"
                  v-loading="loading"
                  element-loading-text="数据分析中"
                  @filter-change="filterChanged"
                  @expand-change="expandChange"
        >
<!--            <el-table-column type="index" width="60" align="center"></el-table-column>-->

            <el-table-column type="expand" width="48px">
                <template #default="{row}">
                    <stats-topic-view
                        :topicInfo="topicInfo[row.topicID]"
                        container="div"
                    ></stats-topic-view>
                </template>
            </el-table-column>

            <el-table-column label="题号" prop="number" align="center" :sortable="true"></el-table-column>

            <el-table-column label="题型" prop="topicTypeName" align="center" :sortable="true">
                <template #default="{row}">
                    <type-tag type="topicType" :id="row.topicType" :name="row.topicTypeName"></type-tag>
                </template>
            </el-table-column>

            <el-table-column label="正确答案" prop="keyName" align="center">
                <template #default="{row}">
                    <!-- 单选、多选、判断 -->
                    <span v-if="isChoiceTopic(row.topicType)">{{row.answer}}</span>
                    <!-- 配对 -->
                    <span class="match" v-else-if="isMatchTopic(row.topicType)">{{row.answer}}</span>
                    <!-- 其他题型 -->
                    <span v-else>{{row.answer}}</span>
                </template>
            </el-table-column>

            <el-table-column align="center" v-for="(item, index) in userNames" :key="index">
                <template #header="{$index}">
                    {{item}}
                </template>

                <template #default="{row, column, $index}">
                    <div class="cell-answer" :class="filterData[$index].record[index].result === 1 ? 'right': 'wrong'">
                        <!-- 单选多选判断展示选项，其余展示作答结果 -->
                        <span class="tag" v-if="isChoiceTopic(row.topicType)">{{filterData[$index].record[index].answer || '未作答'}}</span>
                        <span class="text" v-else-if="isMatchTopic(row.topicType)">{{filterData[$index].record[index].answer || '未作答'}}</span>
                        <span class="tag" v-else>{{getPictureRecord(filterData[$index].record[index])}}</span>
<!--                        <span class="tag" v-else>{{resultMap[filterData[$index].record[index].result]}}</span>-->
                    </div>
                </template>
            </el-table-column>

            <el-table-column v-if="isTheory" label="结论" prop="conclusion" align="center" width="180"
                             :filters="filters"
                             :filter-multiple="false"
                             filter-placement="bottom"
            >
                <template #default="{row}">
                    <div class="conclusion">
                        <div class="right" v-if="row.conclusion === 'right'">作答正确</div>
                        <div class="wrong" v-else-if="row.conclusion === 'wrong'">作答错误</div>
                        <div class="same" v-else-if="row.conclusion === 'same'"><i class="el-icon-warning"></i> 作答错误，且选项相同</div>
                        <div v-else>-</div>
                    </div>
                </template>
            </el-table-column>

        </el-table>

    </el-dialog>
</template>

<script>
import api from "@/api";
import StatsTopicView from "@components/Statistics/StatsTopicView";

export default {
    components: {
        StatsTopicView
    },

    props: {
        // 打开/关闭弹框，直接用v-model即可
        value: {
            type: Boolean,
            default: false,
        },

        userIds: {
            type: Array,
            required: true
        },

        examId: {
            type: String,
            required: true,
        },

        paperType: {
            type: Number,
            default: 1   // 1理论 3DR 4CT
        }
    },

    data() {
        return {
            userNames: [],
            listData: [],
            filterData: [],
            filters: [
                {text: '作答正确', value: 'right'},
                {text: '作答错误（选项不同）', value: 'wrong'},
                {text: '作答错误（选项相同）', value: 'same'}
            ],
            resultMap: {
                0: '错误',
                1: '正确',
                2: '超时'
            },
            topicInfoVisible: false,
            topicInfo: {},
        }
    },

    computed: {
        isTheory() {
            return this.paperType === 1
        }
    },

    watch: {
        value(val) {
            // 打开
            if (val) {
                this.initDialog();
            } else {
                this.$refs.similarTable.clearFilter()
            }
        },
    },

    mounted() {

    },

    methods: {
        initDialog() {
            this.getData()
        },

        async getData() {
            let res = await this.$api.getExamSimilarDetail(this.examId, {userIds: this.userIds})
            this.listData = res.package

            if (this.isTheory) {
                // 处理数据
                this.listData.forEach(item => {
                    item.record.forEach(v => {
                        v.answer = v.answer.toString()
                    })
                })

                this.setConclusion()
            }

            this.filterData = this.listData

            this.userNames = this.listData[0].record.map(item => item.userName)

            // 2021/5/26 不加的话elTable高度计算会有问题。是数据变化后都要加这个吗？待观望
            this.$nextTick(() => {
                this.$refs.similarTable.doLayout()
            })
        },

        setConclusion() {
            this.listData.forEach(item => {
                let conclusion = ''
                let result = item.record.every(paper => paper.result)

                if (result) {
                    conclusion = 'right'
                } else {
                    conclusion = 'same'

                    let lastAnswer = item.record[0].answer.toString()
                    // 如果有一个人的选项不同，就不算same
                    item.record.forEach(paper => {
                        let answer = paper.answer.toString()
                        if (!answer || answer !== lastAnswer) {
                            conclusion = 'wrong'
                        }
                        lastAnswer = answer
                    })
                }

                item.conclusion = conclusion
            })
        },

        filterChanged(filters) {
            let key = Object.keys(filters)[0]
            let conclusion = filters[key][0]

            if (conclusion) {
                this.filterData = this.listData.filter(item => item.conclusion === conclusion)
            } else {
                this.filterData = [...this.listData]
            }
        },

        expandChange(row) {
            this.viewTopic(row)
        },

        getPictureRecord(item) {
            if (item.result === 2) {
                return '超时'
            } else {
                return item.isPass ? '安全': '危险'
            }
        },

        viewTopic(row) {
            let {topicID, topicType} = row
            let topicUrl;
            switch (topicType) {
                case 5:
                    topicUrl = api.getDrTopicInPaper(topicID);
                    break;
                case 6:
                    topicUrl = api.getCtTopic(topicID);
                    break;
                default:
                    topicUrl = api.getTheoryTopicDetail(topicID);
                    break;
            }
            topicUrl.then(res => {
                if (res.package) {
                    this.$set(this.topicInfo, topicID, res.package)
                }
            })
        },

        // 单选、多选、判断
        isChoiceTopic(topicType) {
            return [1, 2, 3].includes(topicType)
        },
        isMatchTopic(topicType) {
            return topicType === 4
        },


    },
}
</script>

<style lang="scss">
.exam-similar-detail {
    min-width: 1000px;

    .el-dialog__body {
        padding: 20px 30px;
    }

    .el-table__expand-icon {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        height: 100%;
        margin: auto;
    }

    // 题目预览容器
    .el-table__expanded-cell {
        padding: 0 30px;
    }

    .number {
        color: $blue;
        cursor: pointer;
    }

    .match {
        font-size: 12px;
    }

    .cell-answer {
        //display: block!important;
        text-align: center;

        .tag {
            display: inline-block;
            width: 65px;
            color: #fff;
            border-radius: 4px;
        }

        .text {
            font-size: 12px;
        }

        &.right {
            .tag {
                background-color: $green;
            }
            .text {
                color:$green;
            }
        }
        &.wrong {
            .tag {
                background-color: $red;
            }
            .text {
                color: $red;
            }
        }

    }

    .conclusion {
        .right {
            color: $green;
        }
        .wrong {
            color: $red;
        }
        .same {
            color: $red;
        }
    }

}
</style>
